/* Configurador de patitos Customima (fase 2, sustituye a Zepto) · un solo código para los 6 productos.
   Misma ficha que la de nombres (cm-personalizador): 1 color · 2 patitos (vista previa) · 3 grabados · 4 revisa y confirma.
   - La configuración de cada producto llega en CFG.base (snippet cm-patitos.liquid):
       type 'curve' → los patitos se reparten juntos a lo largo de la cadena (rolo, medida en su foto);
       type 'slots' → puntos de enganche fijos según cuántos patitos haya (eslabones y elásticos).
     colors: [{k, name, swatch, img | imgs{n}, chain, variant, price}] · S: escala real · frame: encuadre mínimo.
   - Escritorio (≥1000 px): la vista previa pasa a la primera fila de la galería (cm-deskbox), como en nombres.
   - Cesta: base + cada patito como línea propia en UNA llamada a /cart/add.js (todo o nada), unidas por _cm_grupo.
     Con «Sin cadena» (st.noBase) solo van los patitos, sueltos y sin _cm_grupo.
     El 3x2 y los códigos los calcula Shopify; cm-grupos-cesta impide quitar patitos sueltos. */
(function () {
  var root = document.querySelector('[data-cm-pat]');
  if (!root) return;
  var CFG = JSON.parse(root.querySelector('script[type="application/json"]').textContent);
  var BASE = CFG.base;
  if (BASE.cats) {
    CFG.ducks = CFG.ducks.filter(function (d) { return BASE.cats.indexOf(d.cat) >= 0; });
    CFG.cats = CFG.cats.filter(function (c) { return BASE.cats.indexOf(c[0]) >= 0; });
  }
  else {
    // los charms solo van en la pulsera de charms
    CFG.ducks = CFG.ducks.filter(function (d) { return d.cat !== 'charms'; });
    CFG.cats = CFG.cats.filter(function (c) { return c[0] !== 'charms'; });
  }
  CFG.max = BASE.max || CFG.max;
  var BY = {};
  CFG.ducks.forEach(function (d) { BY[d.k] = d; });
  var FORM_ID = root.getAttribute('data-form-id');
  var html = document.documentElement;
  html.classList.add('cm-pat');

  var st = window.__cmPat || (window.__cmPat = { color: BASE.colors[0].k, items: [], cat: CFG.cats[0][0], focus: -1, engrOpen: false });
  if (!BASE.colors.some(function (c) { return c.k === st.color; })) st.color = BASE.colors[0].k;

  var q = function (sel) { return document.querySelector(sel); };
  var eur = function (c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  function color() { for (var i = 0; i < BASE.colors.length; i++) if (BASE.colors[i].k === st.color) return BASE.colors[i]; return BASE.colors[0]; }
  function basePrice() { return color().price || CFG.price; }
  function baseVariant() { return color().variant || CFG.variant; }
  function noun() { return BASE.noun || 'Collar'; }
  // «Sin cadena»: solo los patitos, como colgantes sueltos (28-sep-2026). Cadena y pulsera son «la»; elástico, «lo».
  function baseN() { return BASE.baseName || 'Cadena'; }
  function baseFem() { return /a$/i.test(baseN()); }
  function noBaseTxt() { return 'Sin ' + baseN().toLowerCase(); }
  function track(name, data) { try { window.Shopify && Shopify.analytics && Shopify.analytics.publish('customima_patitos_' + name, data || {}); } catch (e) {} }

  // ---------- Cadena rolo (type 'curve'): centro del hilo, lado izquierdo; el derecho es simétrico.
  // Las fotos plata y dorada NO son iguales: misma escala de eslabón, pero la dorada cuelga más abajo (punto bajo 868 frente a 683).
  var CHAIN = {
    W: { mirror: 1006, bottom: 683, L: [[162,0],[168,50],[178,100],[188,150],[200,200],[210,250],[223,300],[240,350],[253,400],[273,450],[293,500],[318,550],[352,600],[403,650],[503,683]] },
    Y: { mirror: 1004, bottom: 868, L: [[138,0],[142,50],[148,100],[156,150],[164,200],[172,250],[180,300],[191,350],[203,400],[214,450],[227,500],[241,550],[257,600],[277,650],[300,700],[328,750],[366,800],[425,850],[502,868]] }
  };
  var PATH, SEG, TOT, pathKey;
  function chainOf() { return CHAIN[color().chain] || CHAIN.W; }
  function usePath() {
    var key = BASE.path ? 'path' : (color().chain || 'W');
    if (pathKey === key) return;
    var c = chainOf();
    // BASE.path: recorrido completo medido en la foto (pulsera de charms); si no, media cadena reflejada
    PATH = BASE.path ? BASE.path.slice() : c.L.concat(c.L.slice(0, -1).reverse().map(function (p) { return [c.mirror - p[0], p[1]]; }));
    SEG = []; TOT = 0;
    for (var i = 1; i < PATH.length; i++) { var a = PATH[i - 1], b = PATH[i], l = Math.hypot(b[0] - a[0], b[1] - a[1]); SEG.push([a, b, TOT, l]); TOT += l; }
    pathKey = key;
  }
  // punto medio de la curva: el más bajo si hay recorrido propio (la parte delantera de la pulsera)
  function mid0() { if (!BASE.path) return TOT / 2; if (BASE.midX) { for (var i = 0; i < SEG.length; i++) if (SEG[i][1][0] >= BASE.midX) return SEG[i][2] + (BASE.midX - SEG[i][0][0]) / ((SEG[i][1][0] - SEG[i][0][0]) || 1) * SEG[i][3]; } var low = 0; for (var j = 0; j < SEG.length; j++) if (SEG[j][1][1] > SEG[low][1][1]) low = j; return SEG[low][2] + SEG[low][3]; }
  function angAt(s) { for (var j = 0; j < SEG.length; j++) { var g = SEG[j]; if (s <= g[2] + g[3] || j === SEG.length - 1) return Math.atan2(g[1][1] - g[0][1], g[1][0] - g[0][0]) * 180 / Math.PI; } return 0; }
  function at(s) { for (var j = 0; j < SEG.length; j++) { var g = SEG[j]; if (s <= g[2] + g[3]) { var t = (s - g[2]) / g[3]; return [g[0][0] + (g[1][0] - g[0][0]) * t, g[0][1] + (g[1][1] - g[0][1]) * t]; } } return PATH[PATH.length - 1]; }
  // Tamaño REAL: todas las fotos recortadas están a la misma escala (la anilla mide ~55 px en todas).
  // Cada base trae su escala S (rolo 0,38, calculada con eslabón frente a anilla en la foto real). Tamaño fijo: no cambia al añadir patitos.
  var S = BASE.S || 0.38;
  // Punto por donde pasa la cadena (dentro de la anilla) y extremos de cada foto; se mide al cargarla (por defecto, Mamá Pata)
  var GEO = {};
  // Elástico: la anilla sube un poco para que el cordón pase por dentro (medido en escala del patito)
  var HANG = (BASE.hang || 0) * S;
  // Pulsera de charms: anclaje medido en cada charm (el cordón pasa por el agujero), no se mide la anilla
  function geo(k) { return (BASE.geo && BASE.geo[k]) || GEO[k] || { ax: 445, ay: 255, l: 106, r: 216, b: 770 }; }
  function layout(n) {
    var g = st.items.map(function (it) { return geo(it.k); });
    if (BASE.type === 'slots') {
      var slots = (BASE.slots && BASE.slots[n]) || [];
      return g.map(function (gg, k) { var p = slots[k] || [500, 600]; return { x: p[0], y: p[1] - HANG, cy: p[1], a: p[2] || 0, s: S, g: gg }; });
    }
    usePath();
    // Juntos, casi tocándose, centrados en el punto más bajo de la cadena
    var offs = [0];
    for (var k = 1; k < n; k++) offs.push(offs[k - 1] + (g[k - 1].r + g[k].l) * S * (BASE.gap || 0.97));
    var mid = n ? (offs[0] - g[0].l * S + offs[n - 1] + g[n - 1].r * S) / 2 : 0;
    return g.map(function (gg, k) { var sk = mid0() + offs[k] - mid, p = at(sk); return { x: p[0], y: p[1], a: BASE.rotate ? +angAt(sk).toFixed(1) : 0, s: S, g: gg }; });
  }

  // Anilla y extremos de cada foto, medidos al cargarla
  CFG.ducks.forEach(function (d) {
    var im = new Image(); im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        var c2 = document.createElement('canvas'); c2.width = c2.height = 250; var x2 = c2.getContext('2d'); x2.drawImage(im, 0, 0, 250, 250);
        var a = x2.getImageData(0, 0, 250, 250).data, top = -1, minX = 250, maxX = 0, maxY = 0, ring = [];
        for (var yy = 0; yy < 250; yy++) for (var xx = 0; xx < 250; xx++) if (a[(yy * 250 + xx) * 4 + 3] > 40) { if (top < 0) top = yy; if (xx < minX) minX = xx; if (xx > maxX) maxX = xx; if (yy > maxY) maxY = yy; if (yy - top < 10) ring.push(xx); }
        if (top >= 0 && ring.length) {
          var ax = ring.reduce(function (p, v) { return p + v; }, 0) / ring.length * 4;
          GEO[d.k] = { ax: ax, ay: top * 4 + 24, l: ax - minX * 4, r: maxX * 4 - ax, b: maxY * 4 };
        }
      } catch (e) {}
      drawSvg(); };
    im.src = d.src;
  });

  // ---------- Escritorio: la vista previa es la primera fila de la galería (igual que nombres)
  var stage = root.querySelector('[data-cmp-stage]'), note = root.querySelector('.cm-p__note'), anchor = root.querySelector('[data-cmp-cats]');
  var mqDesk = window.matchMedia ? window.matchMedia('(min-width: 1000px)') : null;
  var deskActive = function () { return !/[?&]cmdesk=0/.test(location.search) && !!mqDesk && mqDesk.matches; };
  function placeStage() {
    var grid = q('product-gallery .product-gallery__image-list');
    if (deskActive() && grid) {
      html.classList.add('cm-desk');
      var box = grid.querySelector(':scope > .cm-deskbox');
      document.querySelectorAll('.cm-deskbox').forEach(function (x) { if (x !== box) x.remove(); });
      if (!box) { box = document.createElement('div'); box.className = 'cm-deskbox'; }
      if (grid.firstChild !== box) grid.insertBefore(box, grid.firstChild);
      if (stage.parentNode !== box) box.appendChild(stage);
      if (note && note.parentNode !== box) box.appendChild(note);
    } else {
      html.classList.remove('cm-desk');
      if (stage.parentNode !== root) { root.insertBefore(stage, anchor); if (note) root.insertBefore(note, anchor); }
    }
  }

  function baseImg(n) {
    var c = color();
    if (c.imgs) { var m = Math.max(1, Math.min(n, CFG.max)); return c.imgs[m] || c.imgs[1]; }
    return c.img;
  }
  function viewBox(minx, miny, maxx, maxy, minW) {
    var pad = 30, w = maxx - minx + pad * 2, hh = maxy - miny + pad * 2;
    if (w < minW) w = minW;
    if (w < hh * 2) w = hh * 2; else hh = w / 2;
    var cx = (minx + maxx) / 2, cy = (miny + maxy) / 2;
    return (cx - w / 2).toFixed(0) + ' ' + (cy - hh / 2).toFixed(0) + ' ' + w.toFixed(0) + ' ' + hh.toFixed(0);
  }
  var FRAMES = {};
  function fixedFrame() {
    var key = BASE.type === 'slots' ? 's' : (color().chain || 'W');
    if (FRAMES[key]) return FRAMES[key];
    var D = { ax: 445, ay: 255, l: 106, r: 216, b: 770 }, m = CFG.max, pts = [], minx, miny, maxx, maxy, minW;
    if (BASE.type === 'slots') {
      var fr = BASE.frame; minx = fr[0]; miny = fr[1]; maxx = fr[2]; maxy = fr[3]; minW = 0;
      for (var n = 1; n <= m; n++) ((BASE.slots && BASE.slots[n]) || []).forEach(function (p) { pts.push({ x: p[0], y: p[1] - HANG, a: p[2] || 0 }); });
    } else {
      usePath();
      if (BASE.path) { D = BASE.geo[Object.keys(BASE.geo)[0]]; D = { ax: D.ax, ay: D.ay, l: 151, r: 151, b: 620 }; var fr2 = BASE.frame; minx = fr2[0]; miny = fr2[1]; maxx = fr2[2]; maxy = fr2[3]; minW = 0; }
      else { var bot = chainOf().bottom; minx = 330; maxx = 680; miny = bot - 123; maxy = bot + 37; minW = 820; }
      var step = (D.r + D.l) * S * (BASE.gap || 0.97), mid = ((m - 1) * step + (D.r - D.l) * S) / 2;
      for (var k = 0; k < m; k++) { var sk = mid0() + k * step - mid, p = at(sk); pts.push({ x: p[0], y: p[1], a: BASE.rotate ? angAt(sk) : 0 }); }
    }
    // Si el patito va inclinado, cuenta las esquinas giradas alrededor de su anilla
    pts.forEach(function (p) {
      var r = (p.a || 0) * Math.PI / 180, c = Math.cos(r), sn = Math.sin(r);
      [[-D.l * S, -50], [D.r * S, -50], [-D.l * S, (D.b - D.ay) * S], [D.r * S, (D.b - D.ay) * S]].forEach(function (q) {
        var x = p.x + q[0] * c - q[1] * sn, y = p.y + q[0] * sn + q[1] * c;
        minx = Math.min(minx, x); maxx = Math.max(maxx, x); miny = Math.min(miny, y); maxy = Math.max(maxy, y);
      });
    });
    return (FRAMES[key] = viewBox(minx, miny, maxx, maxy, minW));
  }
  function drawSvg() {
    var svg = stage.querySelector('svg'), n = st.items.length, pos = layout(n);
    // sin cadena: la base se ve difuminada, solo como referencia de cómo quedan los patitos
    var bo = st.noBase ? ' opacity=".25"' : '';
    var h = '<rect x="-600" y="-600" width="2200" height="2200" fill="#fff"/><image href="' + baseImg(n) + '" x="0" y="0" width="1000" height="1000"' + bo + '/>';
    st.items.forEach(function (it, k) {
      var d = BY[it.k], p = pos[k], s = p.s;
      var op = st.focus >= 0 && st.focus !== k ? ' opacity=".5"' : '';
      h += '<g transform="translate(' + p.x.toFixed(1) + ' ' + p.y.toFixed(1) + ')' + (p.a ? ' rotate(' + p.a + ')' : '') + ' translate(' + (-p.g.ax * s).toFixed(1) + ' ' + (-p.g.ay * s).toFixed(1) + ') scale(' + s + ')"' + op + ' data-i="' + k + '" style="cursor:pointer">';
      h += '<image href="' + d.src + '" width="1000" height="1000"/>';
      h += '</g>';
      // charms: la pulsera entra por el agujero → se vuelve a pintar la cadena solo dentro del agujero (mismo giro que el charm)
      var ho = BASE.holes && BASE.holes[it.k];
      if (ho) {
        var tr = 'translate(' + p.x.toFixed(1) + ' ' + p.y.toFixed(1) + ')' + (p.a ? ' rotate(' + p.a + ')' : '') + ' translate(' + (-p.g.ax * s).toFixed(1) + ' ' + (-p.g.ay * s).toFixed(1) + ') scale(' + s + ')';
        h += '<clipPath id="cmpHole' + k + '"><ellipse transform="' + tr + '" cx="' + ho.cx + '" cy="' + ho.cy + '" rx="' + (ho.rx * 1.6).toFixed(1) + '" ry="' + ho.ry + '"/></clipPath>';
        h += '<image href="' + baseImg(n) + '" x="0" y="0" width="1000" height="1000" clip-path="url(#cmpHole' + k + ')" style="pointer-events:none"' + bo + '/>';
      }
    });
    // El cordón vuelve a pintarse por delante de la parte alta de cada anilla (solo el cordón: el blanco de la foto se vuelve transparente)
    if (BASE.cordFront && n) {
      h += '<defs><filter id="cmpCord" color-interpolation-filters="sRGB"><feColorMatrix type="matrix" values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 -10 -10 -10 0 29"/></filter>';
      pos.forEach(function (p, k) { h += '<clipPath id="cmpCordC' + k + '"><rect x="' + (p.x - 60 * p.s).toFixed(1) + '" y="' + (p.cy - 40 * p.s).toFixed(1) + '" width="' + (120 * p.s).toFixed(1) + '" height="' + (80 * p.s).toFixed(1) + '"/></clipPath>'; });
      h += '</defs>';
      pos.forEach(function (p, k) { h += '<image href="' + baseImg(n) + '" x="0" y="0" width="1000" height="1000" filter="url(#cmpCord)" clip-path="url(#cmpCordC' + k + ')" style="pointer-events:none"' + bo + '/>'; });
    }
    svg.innerHTML = h;
    stage.querySelector('[data-cmp-empty]').hidden = n > 0;
    var nb = stage.querySelector('.cmp-nobase');
    if (!nb) { nb = document.createElement('p'); nb.className = 'cmp-empty cmp-nobase'; nb.innerHTML = '<span></span>'; stage.appendChild(nb); }
    nb.hidden = !st.noBase;
    nb.firstChild.textContent = (baseFem() ? 'La ' : 'El ') + baseN().toLowerCase() + ' no se incluye';
    // Encuadre FIJO por producto y color: el que cabe con el máximo de patitos. Así la joya nunca cambia de tamaño
    // al añadir o quitar patitos (ni hace zoom sobre la base vacía).
    svg.setAttribute('viewBox', fixedFrame());
  }

  // ---------- Paso 1: color de la cadena, la pulsera o el elástico
  function drawColor() {
    var box = q('[data-cmp-colors]');
    if (!box) return;
    if (!box.innerHTML.trim()) {
      box.innerHTML = '<div class="cmp-card"><span class="cmp-card__l">Color</span><div class="cmp-card__v" role="group" aria-label="' + esc(BASE.colorLabel || 'Color') + '">' +
        BASE.colors.map(function (c) { return '<button type="button" class="cmp-sw" style="background:' + esc(c.swatch) + '" data-color="' + esc(c.k) + '" aria-label="' + esc(c.name) + '" title="' + esc(c.name) + '"></button>'; }).join('') +
        '<span class="cmp-card__name" data-cmp-colorname></span>' +
        '<button type="button" class="cmp-nobase-btn" data-nobase="1">' + esc(noBaseTxt()) + ' <small>(ya ' + (baseFem() ? 'la' : 'lo') + ' tengo)</small></button></div></div>';
    }
    box.querySelectorAll('[data-color]').forEach(function (x) { x.setAttribute('aria-pressed', !st.noBase && x.getAttribute('data-color') === st.color); });
    var nbb = box.querySelector('[data-nobase]'); if (nbb) nbb.setAttribute('aria-pressed', !!st.noBase);
    box.querySelector('[data-cmp-colorname]').textContent = st.noBase ? '' : color().name;
  }

  // ---------- Paso 2: categorías y carrusel
  function drawCats() {
    var c = root.querySelector('[data-cmp-cats]');
    c.hidden = CFG.cats.length < 2;
    c.innerHTML = CFG.cats.map(function (x) { return '<button type="button" class="cmp-cat" data-cat="' + x[0] + '" aria-pressed="' + (st.cat === x[0]) + '">' + x[1] + '</button>'; }).join('');
  }
  function drawCar() {
    var full = st.items.length >= CFG.max;
    root.querySelector('[data-cmp-car]').innerHTML = CFG.ducks.filter(function (d) { return d.cat === st.cat; }).map(function (d) {
      var c = st.items.filter(function (it) { return it.k === d.k; }).length;
      return '<button type="button" class="cmp-duck" data-add="' + d.k + '"' + (full || d.off ? ' disabled' : '') + ' aria-label="Añadir ' + esc(d.name) + ', ' + eur(d.price) + '">' +
        (c ? '<span class="cmp-duck__n">' + c + '</span>' : '') + '<span class="cmp-duck__plus" aria-hidden="true">+</span>' +
        '<img src="' + d.src + '" alt="" loading="lazy" width="80" height="66"><span class="cmp-duck__name">' + esc(d.name) + '</span><span class="cmp-duck__p">+' + eur(d.price) + '</span></button>';
    }).join('');
  }

  // Flechas del carrusel: en ordenador la rueda no desliza en horizontal; se ocultan al llegar a cada extremo
  function arrows() {
    var car = root.querySelector('[data-cmp-car]'), prev = root.querySelector('[data-cmp-scroll="-1"]'), next = root.querySelector('[data-cmp-scroll="1"]');
    if (!car || !prev || !next) return;
    prev.hidden = car.scrollLeft <= 2;
    next.hidden = car.scrollLeft + car.clientWidth >= car.scrollWidth - 2;
  }
  root.querySelector('[data-cmp-car]').addEventListener('scroll', arrows, { passive: true });
  window.addEventListener('resize', arrows);

  // ---------- Paso 3: grabados
  function drawEngr() {
    var box = q('[data-cmp-engr]');
    if (!box) return;
    if (!st.items.length) { box.innerHTML = '<p class="cmp-engr__empty">Primero añade tus patitos.</p>'; return; }
    if (!st.engrOpen) {
      var hechos = st.items.filter(listo).length;
      box.innerHTML = '<button type="button" class="cmp-open" data-cmp-open aria-expanded="false"><span>Grabamos por detrás el nombre o la fecha de ' + (st.items.length > 1 ? 'cada patito' : 'tu patito') + ' (opcional)' + (hechos ? ' <small>(' + hechos + ' de ' + st.items.length + ')</small>' : '') + '</span><b>Grabar ▾</b></button>';
      return;
    }
    box.innerHTML = '<div class="cmp-engr">' + st.items.map(function (it, k) {
      var d = BY[it.k];
      return '<div class="cmp-row">' +
        '<div class="cmp-row__img"><span class="cmp-row__n">' + (k + 1) + '</span><img src="' + d.src + '" alt=""><button type="button" class="cmp-row__x" data-rm="' + k + '" aria-label="Quitar ' + esc(d.name) + '">✕</button></div>' +
        '<div class="cmp-row__in"><label for="cmp-g' + k + '">' + esc(d.name) + '</label><textarea id="cmp-g' + k + '" data-g="' + k + '" rows="2" autocomplete="off" autocapitalize="sentences" spellcheck="false" placeholder="' + (it.none ? 'Sin grabado' : 'Nombre o fecha') + '"' + (it.none ? ' disabled' : '') + '>' + (it.none ? '' : esc(it.txt || '')) + '</textarea>' +
        '<label class="cmp-none"><input type="checkbox" data-none="' + k + '"' + (it.none ? ' checked' : '') + '> Este patito sin grabado</label></div>' +
        '<div class="cmp-row__sym"><button type="button" class="cmp-sym" data-sym="♥" data-row="' + k + '" aria-label="Añadir corazón">♥</button><button type="button" class="cmp-sym" data-sym="∞" data-row="' + k + '" aria-label="Añadir infinito">∞</button></div>' +
        '</div>';
    }).join('') + '<p class="cm-p__hint">El grabado va por la parte de detrás del patito. Hasta 2 líneas de ' + CFG.maxChars + ' caracteres; ♥ y ∞ también se graban.</p></div>' +
      (st.items.length > 1 ? '<label class="cm-p__check"><input type="checkbox" data-noengrave' + (allNone() ? ' checked' : '') + '><span>Ninguno lleva grabado</span></label>' : '');
  }

  // 3x2: Shopify regala el más barato de cada 3 colgantes de la promo. Estimación para enseñar; manda la cesta.
  function promo() { var p = st.items.map(function (it) { return BY[it.k].price; }).sort(function (a, b) { return b - a; }), f = 0; for (var k = 2; k < p.length; k += 3) f += p[k]; return f; }
  function lines2(t) { return String(t || '').split('\n').map(function (x) { return x.trim(); }).filter(Boolean).slice(0, 2); }
  // 2 líneas como máximo y maxChars por línea; mayúsculas y minúsculas tal cual las escribe la clienta
  function clean(t) { return String(t || '').split('\n').slice(0, 2).map(function (x) { return x.slice(0, CFG.maxChars); }).join('\n'); }
  function listo(it) { return !!it.none || lines2(it.txt).length > 0; }
  function allNone() { return st.items.length > 0 && st.items.every(function (it) { return it.none; }); }
  function engravedAll() { return st.items.length > 0 && st.items.every(listo); }
  function grab(it) { return it.none ? '' : lines2(it.txt).join(' / '); }

  // ---------- Pasos + paso 4: revisa y confirma (cm-sum, igual que nombres)
  // En el resumen no se dice «Plata» (parecería que solo la cadena es de plata); sí Dorado, Bicolor o el color del elástico
  function sumColor() { return st.noBase || color().name === 'Plata' ? '' : color().name; }
  function drawGuide() {
    var n = st.items.length, pats = st.items.reduce(function (s, it) { return s + BY[it.k].price; }, 0), total = (st.noBase ? 0 : basePrice()) + pats, free = promo(), final = total - free;
    // «Desde» = base más barata + patito más barato (igual en precio de arriba, resumen y barra fija)
    var minBase = Math.min.apply(null, BASE.colors.map(function (c) { return c.price || CFG.price; }));
    var desde = minBase + Math.min.apply(null, CFG.ducks.filter(function (d) { return !d.off; }).map(function (d) { return d.price; }));
    var totalTxt = n ? eur(final) : 'Desde ' + eur(desde);
    var set = function (num, done, active) { var s = q('[data-cm-step="' + num + '"]'); if (s) { s.classList.toggle('is-done', !!done); s.classList.toggle('is-active', !done && !!active); } };
    set(1, true);
    set(2, n > 0, true);
    // grabado opcional: con patitos, el paso 3 ya cuenta como hecho y se puede confirmar
    set(3, n > 0, n > 0);
    set(4, false, n > 0);

    var box = q('[data-cm-resumen]');
    if (box) {
      var design;
      // hay algún patito vacío que la clienta no ha marcado a propósito como «sin grabado»
      var vacios = st.items.some(function (it) { return !it.none && !grab(it); });
      if (!n) design = '<button type="button" class="cm-sum__todo" data-cmp-goto="2">Falta añadir tus patitos</button>';
      else design = st.items.map(function (it) { return '<small>' + esc(BY[it.k].name) + ':</small> ' + (grab(it) ? '«' + esc(grab(it)) + '»' : 'sin grabado'); }).join('<br>') +
        (vacios ? '<br><button type="button" class="cm-sum__todo" data-cmp-goto="3">¿Quieres grabarlos? Es gratis</button>' : '');
      if (html.classList.contains('cm-desk')) {
        // escritorio: una sola línea corta para que el botón quede en la primera pantalla
        var line = !n ? '<button type="button" class="cm-sum__todo" data-cmp-goto="2">Añade patitos</button>'
          : vacios ? n + ' patito' + (n > 1 ? 's' : '') + ' · <button type="button" class="cm-sum__todo" data-cmp-goto="3">Añadir grabado (gratis)</button>'
          : n + ' patito' + (n > 1 ? 's' : '') + (allNone() ? ' sin grabado' : ' listo' + (n > 1 ? 's' : ''));
        box.innerHTML = '<div class="cm-sum cm-sum--line"><div><small>Tu diseño</small>' + line + (st.noBase ? ' · ' + esc(noBaseTxt().toLowerCase()) : '') + (sumColor() ? ' · ' + esc(sumColor()) : '') + (free ? ' · <span style="color:#2f7a4b">3x2 −' + eur(free).replace(',00', '') + '</span>' : '') + '</div><b>' + totalTxt + '</b></div>' +
          '<p class="cm-sum__free">Grabado incluido en el precio</p>';
      } else {
        box.innerHTML = '<div class="cm-sum">' +
          '<div class="cm-sum__row"><span>Tu diseño</span><strong>' + design + '</strong></div>' +
          '<div class="cm-sum__row"><span>' + esc(baseN()) + '</span><span>' + (st.noBase ? 'No incluid' + (baseFem() ? 'a' : 'o') : (sumColor() ? esc(sumColor()) + ' · ' : '') + eur(basePrice())) + '</span></div>' +
          (n ? '<div class="cm-sum__row"><span>' + n + ' patito' + (n > 1 ? 's' : '') + '</span><span>' + eur(pats) + '</span></div>' : '') +
          (free ? '<div class="cm-sum__row cm-sum__row--ok"><span>🔥 3x2 en patitos</span><span>−' + eur(free) + '</span></div>' : '') +
          '<div class="cm-sum__row cm-sum__total"><span>Total</span><strong>' + totalTxt + '</strong></div>' +
          (n % 3 === 2 ? '<p class="cm-sum__free">Añade 1 patito más y el más barato te sale gratis (3x2).</p>' : '<p class="cm-sum__free">Grabado incluido en el precio</p>') + '</div>';
      }
    }
    // precio del tema (bloque precio y barra fija). 28-sep-2026: sin patitos se enseña el precio de la base
    // (el mismo que en colección, anuncios y datos de Google) y debajo «+ patitos desde»; antes era «Desde» base + patito.
    var minDuck = Math.min.apply(null, CFG.ducks.filter(function (d) { return !d.off; }).map(function (d) { return d.price; }));
    var label = n ? eur(final) : st.noBase ? 'Patitos desde ' + eur(minDuck) : eur(basePrice());
    var sub = n || st.noBase ? '' : '+ patitos desde ' + eur(minDuck).replace(',00', '');
    document.querySelectorAll('.product-info sale-price').forEach(function (sp) {
      var t = sp.lastChild; if (t && t.nodeType === 3) t.nodeValue = label.replace(' €', '€');
      var list = sp.closest('price-list') || sp.parentNode, s = list.parentNode.querySelector('.cmp-price-sub');
      if (!s) { s = document.createElement('p'); s.className = 'cmp-price-sub'; list.parentNode.insertBefore(s, list.nextSibling); }
      s.textContent = sub; s.hidden = !sub;
    });
    var bar = q('product-sticky-bar');
    if (bar) {
      var chip = bar.querySelector('.cmp-sticky');
      if (!chip) { chip = document.createElement('div'); chip.className = 'cmp-sticky'; var bb = bar.querySelector('buy-buttons'); bb && bb.parentNode.insertBefore(chip, bb); }
      chip.innerHTML = '<small>' + (n ? (st.noBase ? '' : noun() + ' + ') + n + ' patito' + (n > 1 ? 's' : '') : st.noBase ? 'Patitos desde' : esc(baseN()) + ' (+ patitos desde ' + eur(minDuck).replace(',00', '') + ')') + '</small><b>' + (n ? eur(final) : st.noBase ? eur(minDuck) : eur(basePrice())) + '</b>';
    }
  }

  function openEngr(focus) {
    if (!st.items.length) return;
    if (!st.engrOpen) { st.engrOpen = true; drawEngr(); track('grabado_abierto', { n: st.items.length }); }
    if (focus) {
      var empty = [].slice.call(document.querySelectorAll('[data-cmp-engr] textarea')).filter(function (x) { return !x.value && !x.disabled; })[0];
      if (empty) setTimeout(function () { empty.focus({ preventScroll: true }); }, 400);
    }
  }
  // «Llegar» = el título del paso 3 entra en la mitad baja de la pantalla haciendo scroll, con patitos ya elegidos
  var scrolled = false;
  function engrCheck() {
    if (st.engrOpen || !st.items.length || !scrolled) return;
    var s3 = q('[data-cm-step="3"]'); if (!s3) return;
    var r = s3.getBoundingClientRect();
    if (r.top < window.innerHeight * 0.75 && r.bottom > 0) openEngr(false);
  }
  window.addEventListener('scroll', function () { scrolled = true; engrCheck(); }, { passive: true });

  function all() { drawSvg(); drawColor(); drawCar(); drawEngr(); drawGuide(); }

  // ---------- Eventos (delegados en document: los pasos viven en bloques distintos de la ficha)
  function goto(step) {
    if (step === '2') { root.scrollIntoView({ block: 'center', behavior: 'smooth' }); return; }
    var s3 = q('[data-cm-step="3"]'); s3 && s3.scrollIntoView({ block: 'start', behavior: 'smooth' });
    openEngr(true);
  }
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-color],[data-nobase],[data-cat],[data-cmp-scroll],[data-add],[data-rm],[data-sym],[data-i],[data-cmp-goto],[data-cmp-open]');
    if (!b) return;
    var ds = b.dataset;
    if (ds.color) { st.color = ds.color; st.noBase = false; drawColor(); drawSvg(); drawGuide(); track('color', { color: st.color }); }
    else if (ds.nobase) { st.noBase = true; drawColor(); drawSvg(); drawGuide(); track('color', { color: 'sin_cadena' }); }
    else if (ds.cat) { st.cat = ds.cat; drawCats(); drawCar(); root.querySelector('[data-cmp-car]').scrollLeft = 0; arrows(); }
    else if (ds.cmpScroll) { var car = root.querySelector('[data-cmp-car]'); car.scrollBy({ left: +ds.cmpScroll * car.clientWidth * 0.8, behavior: 'smooth' }); }
    else if (ds.add) {
      if (st.items.length >= CFG.max) return;
      st.items.push({ k: ds.add, txt: '' });
      root.querySelector('[data-cm-msg]').textContent = '';
      all();
      engrCheck();
      track('add', { patito: ds.add, n: st.items.length });
    }
    else if (ds.rm !== undefined) { st.items.splice(+ds.rm, 1); st.focus = -1; all(); }
    else if (ds.sym) {
      var k = +ds.row, t = q('[data-g="' + k + '"]');
      if (!t || t.disabled) return;
      var v = t.value, p0 = t.selectionStart == null ? v.length : t.selectionStart, p1 = t.selectionEnd == null ? v.length : t.selectionEnd;
      t.value = clean(v.slice(0, p0) + ds.sym + v.slice(p1));
      t.focus(); try { t.setSelectionRange(p0 + 1, p0 + 1); } catch (e) {}
      t.dispatchEvent(new Event('input', { bubbles: true }));
    }
    else if (ds.cmpOpen !== undefined) openEngr(true);
    else if (ds.i !== undefined) { openEngr(false); var inp = q('[data-g="' + ds.i + '"]'); if (inp) { inp.scrollIntoView({ block: 'center', behavior: 'smooth' }); setTimeout(function () { inp.focus({ preventScroll: true }); }, 350); } }
    else if (ds.cmpGoto) goto(ds.cmpGoto);
  });
  document.addEventListener('mousedown', function (ev) { if (ev.target.closest && ev.target.closest('[data-sym]')) ev.preventDefault(); });
  document.addEventListener('input', function (ev) {
    var t = ev.target; if (!t.dataset || t.dataset.g === undefined) return;
    var c = clean(t.value);
    if (c !== t.value) { var pos0 = t.selectionStart; t.value = c; try { t.setSelectionRange(Math.min(pos0, c.length), Math.min(pos0, c.length)); } catch (e) {} }
    st.items[+t.dataset.g].txt = c;
    var need = q('.cmp-need'); if (need) need.remove();
    drawGuide();
  });
  document.addEventListener('change', function (ev) {
    var t = ev.target; if (!t.hasAttribute) return;
    if (t.hasAttribute('data-none')) { st.items[+t.getAttribute('data-none')].none = t.checked; }
    else if (t.hasAttribute('data-noengrave')) { st.items.forEach(function (it) { it.none = t.checked; }); }
    else return;
    var need = q('.cmp-need'); if (need) need.remove();
    drawEngr(); drawGuide();
  });
  document.addEventListener('focusin', function (ev) {
    var t = ev.target; if (!t.dataset || t.dataset.g === undefined) return;
    st.focus = +t.dataset.g; drawSvg();
  });
  document.addEventListener('focusout', function (ev) {
    if (!ev.target.dataset || ev.target.dataset.g === undefined) return;
    setTimeout(function () { var a = document.activeElement; if (!a || !a.dataset || a.dataset.g === undefined) { st.focus = -1; drawSvg(); } }, 150);
  });

  // ---------- Añadir a la cesta: interceptamos el envío del formulario del tema (botón principal y barra fija)
  function payload() {
    var grupo = 'P' + Date.now().toString(36).toUpperCase();
    var c = color();
    var vaEn = noun() + ' patitos ' + c.name.toLowerCase();
    var g = function (it) { return it.none ? 'Sin grabado' : (lines2(it.txt).join('\n') || 'Sin grabado'); };
    // Sin cadena: colgantes sueltos, igual que desde la ficha de cada patito. Sin _cm_grupo ni «Va en»,
    // porque cm-grupos-cesta quita los patitos de un grupo que no tiene base.
    if (st.noBase) return st.items.map(function (it) { return { id: BY[it.k].variant, quantity: 1, properties: { 'Graba tu patito por detrás': g(it) } }; }).reverse();
    var baseProps = {};
    baseProps[BASE.colorKey || '¿Qué color de cadena quieres?'] = c.name;
    baseProps['¿Cuántos patitos quieres añadir?'] = String(st.items.length);
    st.items.forEach(function (it, k) { baseProps['_Patito ' + (k + 1)] = BY[it.k].name; baseProps['Grabado Patito ' + (k + 1)] = g(it); });
    baseProps._cm_grupo = grupo;
    baseProps._cm_diseno = JSON.stringify({ v: 3, color: st.color, vaEn: vaEn, items: st.items.map(function (it) { return { k: it.k, variant: BY[it.k].variant, sinGrabado: !!it.none, lineas: it.none ? [] : lines2(it.txt) }; }) });
    var items = [{ id: baseVariant(), quantity: 1, properties: baseProps }];
    st.items.forEach(function (it, k) {
      items.push({ id: BY[it.k].variant, quantity: 1, properties: { 'Graba tu patito por detrás': g(it), 'Va en': vaEn + ' · posición ' + (k + 1), _cm_grupo: grupo } });
    });
    // la cesta enseña primero lo último añadido: así sale la base arriba y los patitos 1, 2, 3 debajo
    return items.reverse();
  }

  var busy = false;
  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    // ojo: form.id es el input name="id" (variante), no el atributo id
    if (!form || !form.getAttribute || form.getAttribute('id') !== FORM_ID) return;
    ev.preventDefault(); ev.stopImmediatePropagation();
    if (busy) return;
    var msg = root.querySelector('[data-cm-msg]');
    if (!st.items.length) { msg.textContent = 'Añade al menos un patito a tu ' + noun().toLowerCase() + '.'; goto('2'); track('error', { tipo: 'sin_patitos' }); return; }
    // 28-sep-2026: el grabado es opcional; los patitos sin texto van como «Sin grabado» (ver payload)
    add(form);
  }, true);

  function add(form) {
    busy = true;
    var buttons = document.querySelectorAll('button[type="submit"][form="' + FORM_ID + '"]');
    buttons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
    html.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
    var sections = [];
    html.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
    var done = function () { busy = false; buttons.forEach(function (b) { b.removeAttribute('aria-busy'); }); html.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true })); };
    var fail = function (t) { done(); root.querySelector('[data-cm-msg]').textContent = t; root.scrollIntoView({ block: 'center', behavior: 'smooth' }); };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: payload(), sections: sections.join(','), sections_url: location.pathname })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); }).then(function (res) {
      if (!res.ok) { fail(res.j.description || res.j.message || 'No hemos podido añadirlo. Inténtalo de nuevo.'); track('error', { tipo: 'cesta', msg: res.j.description || '' }); return; }
      track('added', { n: st.items.length, color: st.noBase ? 'sin_cadena' : st.color, sin_grabado: st.items.filter(function (it) { return !grab(it); }).length, patitos: st.items.map(function (it) { return it.k; }).join(',') });
      var tv = window.themeVariables && window.themeVariables.settings;
      if (tv && (tv.cartType === 'page' || tv.pageType === 'cart')) { location.href = window.Shopify.routes.root + 'cart'; return; }
      return fetch(window.Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        done();
        cart.sections = res.j.sections;
        form.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: res.j.items || [res.j], cart: cart, onSuccessDo: null } }));
        html.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo: null, cart: cart } }));
      });
    }).catch(function () { fail('No hemos podido añadirlo. Revisa tu conexión e inténtalo de nuevo.'); });
  }

  // Precios y disponibilidad reales de cada colgante (por si cambian en el admin)
  CFG.ducks.forEach(function (d) {
    fetch(window.Shopify.routes.root + 'products/' + d.handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      if (!p) { d.off = true; drawCar(); return; }
      var v = p.variants.filter(function (x) { return x.id === d.variant; })[0];
      if (!v || !v.available) d.off = true; else if (v.price !== d.price) { d.price = v.price; drawGuide(); }
      drawCar();
    }).catch(function () {});
  });

  // Barra fija en móvil: el tema solo la enseña al pasar el botón; aquí también antes de llegar a él
  var mainBtn = null;
  function barCheck() {
    if (!mainBtn || !mainBtn.isConnected) mainBtn = q('.product-info buy-buttons button[type="submit"]');
    if (!mainBtn) return;
    var r = mainBtn.getBoundingClientRect();
    html.classList.toggle('cmp-show-bar', r.bottom < 0 || r.top > window.innerHeight);
  }
  window.addEventListener('scroll', barCheck, { passive: true });
  window.addEventListener('resize', barCheck);

  if (noun() === 'Pulsera') stage.classList.add('cmp-fade');
  var hint = root.querySelector('.cm-p__hint'); if (hint) hint.textContent = 'Hasta ' + CFG.max + ' patitos. Se colocan de izquierda a derecha en el orden en que los añades.';
  placeStage();
  drawCats();
  all();
  arrows();
  setTimeout(arrows, 800);
  barCheck();
  if (mqDesk && mqDesk.addEventListener) mqDesk.addEventListener('change', function () { placeStage(); drawGuide(); });
  // El tema re-renderiza partes de la ficha: recolocamos la vista previa y repintamos pasos si hace falta
  setInterval(function () {
    var grid = q('product-gallery .product-gallery__image-list');
    if (deskActive() && grid && (!stage.isConnected || grid.firstChild !== stage.parentNode)) placeStage();
    var colors = q('[data-cmp-colors]'); if (colors && !colors.innerHTML.trim()) drawColor();
    var eng = q('[data-cmp-engr]'); if (eng && !eng.innerHTML.trim()) drawEngr();
    var res = q('[data-cm-resumen]'); if (res && !res.innerHTML.trim()) drawGuide();
    barCheck(); // por si el navegador no avisa del scroll (p. ej. al volver a la pestaña)
  }, 700);
})();
